import styled from 'styled-components';

export const StyledButton = styled.button`
  background-color: ${props => props.color || props.theme.buttonColor};
  border-radius: 4px;
  color: #fff;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  padding: 5px 10px;
  min-width: 100px;
  ${props => props.fullWidth && 'width: 100%;'}
  :hover {
    background-color: ${props => props.hoverColor || props.theme.buttonHoverColor}
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  ${props => props.alignItems && `align-items: ${props.alignItems}`};
  ${props => props.justifyContent && `justify-content: ${props.justifyContent};`}
  ${props => props.width && `width: ${props.width};`}
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.alignItems && `align-items: ${props.alignItems}`};
  ${props => props.justifyContent && `justify-content: ${props.justifyContent};`}
`;

export const ButtonRow = styled(Row)`
  ${props => props.margin && `${props.margin}px;`}
  button:not(:first-child:last-child) {
    margin: 0 2.5px;
  }
`;